<template>
  <form-section class="chart-wrapper" :class="chartClass" :title="title">
    <template slot="controls">
      <div class="graphTitle clearfix use-deprecated-styles">
        <span style="display:none;"></span>
        <div
          class="options clearfix timelineChart"
          :data-export-table-method="exportTableMethod"
        >
          <el-button
            v-if="exportTableMethod"
            class="opt2Table"
            type="primary"
            icon="el-icon-document"
          >
            {{ $t('Analytics_Button_Export_Table') }}
          </el-button>
          <el-button
            :disabled="!isExportButtonEnabled"
            class="opt2"
            type="primary"
            icon="el-icon-download"
          >
            {{ $t('Analytics_Button_Export') }}
          </el-button>
        </div>
      </div>
    </template>
    <div class="graphWrapper">
      <div class="timelineChart">
        <div class="graph">&nbsp;</div>
        <div class="graphChoice clearfix"></div>
      </div>
      <div v-if="Object.keys(items).length === 0" class="chart-noitems">
        {{ $t('AnalyticsChartWrapper_NoItemsSelected') }}
      </div>
      <div v-else-if="!modifier" class="chart-noitems">
        {{ $t('AnalyticsChartWrapper_NoMetricSelected') }}
      </div>
    </div>
    <slot></slot>
  </form-section>
</template>
<script>
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'AnalyticsChartWrapper',
  components: { FormSection },
  props: {
    chartClass: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: false
    },
    settings: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    chart: {
      required: true
    },
    exportTableMethod: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      chartObj: null,
      modifier: null
    }
  },
  mounted() {
    this.chartObj = this.chart()

    this.modifier = this.chartObj.modifier
    this.chartObj.onModifierChange = modifier => {
      if (!this.modifier) {
        this.modifier = modifier
        this.reload()
      }
      this.modifier = modifier
    }

    this.chartObj.reloadByParam(this.settings, this.options)
  },
  watch: {
    settings: {
      handler() {
        this.chartObj.reloadByParam(this.settings, this.options)
      },
      deep: true
    },
    items: {
      handler() {
        this.chartObj.showItems(this.items)
        this.reload()
      },
      deep: true
    }
  },
  methods: {
    reload() {
      if (this.modifier) {
        this.chartObj.reloadByParam(this.settings, this.options)
      }
    }
  },
  computed: {
    isExportButtonEnabled() {
      return this.modifier && Object.keys(this.items).length
    }
  }
}
</script>

<style scoped lang="scss">
.chart-wrapper {
  position: relative;

  /deep/ .date-picker-button,
  /deep/ .graphModifierSelect {
    margin-left: 20px;
    height: 36px;
    border-radius: 4px;
    line-height: 34px;
    padding-right: 22px;
    border-color: #1d87c8;
    color: #1d87c8;
    font-weight: 600;
    font-size: 14px;
    width: unset;
  }

  /deep/ .date-picker-period {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    top: 60px;
  }

  /deep/ .graphChoice {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    display: flex;

    .choiceWrapper {
      .choiceTitle {
        height: 32px;
        text-transform: uppercase;
        text-align: center;
        line-height: 32px;
        font-size: 12px;
      }

      .choiceColor {
        height: 8px;
        line-height: 8px;
      }

      .choiceValue {
        font-size: 28px;
        text-align: center;
        line-height: 56px;
      }
    }
  }

  /deep/ .form-section-header {
    min-height: 37px;
  }

  .chart-noitems {
    position: absolute;
    width: 100%;
    top: 50%;
    text-align: center;
  }
}

.hidden {
  div.graphWrapper {
    // Height 0 as sometimes charts don't render correctly in hidden containers
    height: 0px;
    overflow: hidden;

    .chart-noitems {
      display: none;
    }
  }

  /deep/ .form-section-header .controls {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/charts/AnalyticsChartWrapper.vue